import React, { useState, useCallback } from 'react';
import { ApolloProvider } from '@apollo/client';
import client from '../lib/apolloClient';
import CommonSenseScoringWizard from '../components/Succeedo/Assessment/CommonSenseScoringWizard';
import AssessmentResults from '../components/Succeedo/Assessment/AssessmentResults';

function SucceedoAssessmentInner({ mode: initialMode }) {
  const [view, setView] = useState(initialMode || 'wizard');
  const [results, setResults] = useState(null);

  const handleComplete = useCallback((data) => {
    setResults(data);
    setView('results');
  }, []);

  if (view === 'results') {
    return <AssessmentResults results={results} />;
  }

  return <CommonSenseScoringWizard onComplete={handleComplete} />;
}

const SucceedoAssessmentContainer = (props, _railsContext) => (
  <ApolloProvider client={client}>
    <SucceedoAssessmentInner mode={props.mode} />
  </ApolloProvider>
);

export default SucceedoAssessmentContainer;
